export default __webpack_public_path__ + "static/media/is_this_you_l.f6901582.jpg";